import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as SalesApiActions from "../actions/SalesApiActions";
import {
  showModalWindow,
  removeModalWindow,
  showWindow,
  removeWindow
  } from "../actions/WindowActions";

// Handle GUI for cancelling sales order.
function* requestCancelSalesOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelSalesOrderWindow", {id: baseAction.id}, "Cancel Sales Order"));
  yield take([SalesApiActions.CANCEL_SALES_ORDER.CANCEL, SalesApiActions.CANCEL_SALES_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCancelSalesOrder() {
  yield takeLatest(SalesApiActions.REQUEST_CANCEL_SALES_ORDER, requestCancelSalesOrder);
}

// Handle GUI for creating promo codes.
function* requestCreatePromoCode(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "CreatePromoCodeWindow", {}, "Create New Promo Code"));
  yield take([SalesApiActions.CREATE_PROMO_CODE.CANCEL, SalesApiActions.CREATE_PROMO_CODE.SUCCESS]);
  yield put(removeWindow(windowId));
}
function* watchRequestCreatePromoCode() {
  yield takeLatest(SalesApiActions.REQUEST_CREATE_PROMO_CODE, requestCreatePromoCode);
}

// Handle GUI for editing promo codes.
function* requestEditPromoCode(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "EditPromoCodeWindow", {code: baseAction.code}, "Edit Promo Code"));
  yield take([SalesApiActions.EDIT_PROMO_CODE.CANCEL, SalesApiActions.EDIT_PROMO_CODE.SUCCESS]);
  yield put(removeWindow(windowId));
}
function* watchRequestEditPromoCode() {
  yield takeLatest(SalesApiActions.REQUEST_EDIT_PROMO_CODE, requestEditPromoCode);
}

// Void Charge.
function* requestVoidCharge(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "VoidChargeWindow", {salesOrderId: baseAction.salesOrderId}, `Void Charge`));
  yield take([SalesApiActions.VOID_CHARGE.CANCEL, SalesApiActions.VOID_CHARGE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestVoidCharge() {
  yield takeLatest(SalesApiActions.REQUEST_VOID_CHARGE, requestVoidCharge);
}

// Request Create Referral Code.
function* requestCreateReferralCode(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateReferralCodeWindow", {}, `Create Referral Code`));
  yield take([SalesApiActions.CREATE_REFERRAL_CODE.CANCEL, SalesApiActions.CREATE_REFERRAL_CODE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateReferralCode() {
  yield takeLatest(SalesApiActions.REQUEST_CREATE_REFERRAL_CODE, requestCreateReferralCode);
}

// Request Edit Referral Code.
function* requestEditReferralCode(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditReferralCodeWindow", {code: baseAction.code}, `Edit Referral Code`));
  yield take([SalesApiActions.EDIT_REFERRAL_CODE.CANCEL, SalesApiActions.EDIT_REFERRAL_CODE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditReferralCode() {
  yield takeLatest(SalesApiActions.REQUEST_EDIT_REFERRAL_CODE, requestEditReferralCode);
}

// View Meta Order History.
function* requestViewMetaOrderHistory(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "MetaOrderHistoryWindow", {metaOrderId: baseAction.metaOrderId}, `Meta Order History`));
}
function* watchRequestViewMetaOrderHistory() {
  yield takeLatest(SalesApiActions.REQUEST_VIEW_META_ORDER_HISTORY, requestViewMetaOrderHistory);
}

export default function* saga() {
  yield fork(watchRequestCancelSalesOrder);
  yield fork(watchRequestCreatePromoCode);
  yield fork(watchRequestEditPromoCode);
  yield fork(watchRequestVoidCharge);
  yield fork(watchRequestCreateReferralCode);
  yield fork(watchRequestEditReferralCode);
  yield fork(watchRequestViewMetaOrderHistory);
}
